<template>
  <a
    :href="hikeUrl"
    target="_blank"
    rel="noopener"
    class="hiiker-branding"
    :class="{ docked }"
    :title="hikeName ? $t('hike_map_embed.hiiker_branding.view_hike_on_hiiker', { name: hikeName }) : $t('hike_map_embed.hiiker_branding.view_this_hike_on_hiiker')"
  >
    <img :src="logoSrc" alt="HiiKER" class="hiiker-logo" />
    <span class="branding-text">{{ $t('hike_map_embed.hiiker_branding.view_on_hiiker') }}</span>
  </a>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import hiikerLogo from '../../../images/hiiker-logo-white.svg';

export default defineComponent({
  name: 'HiikerBranding',
  props: {
    hikeUrl: {
      type: String,
      required: true
    },
    hikeName: {
      type: String,
      default: ''
    },
    // Stacked layout: sit in the title bar instead of floating over the map.
    docked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logoSrc: hiikerLogo
    };
  }
});
</script>

<style scoped>
.hiiker-branding {
  position: absolute;
  top: 8px;
  right: 54px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: rgba(40, 42, 50, 0.92);
  backdrop-filter: blur(8px);
  border-radius: 6px;
  text-decoration: none;
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  transition: all 0.2s ease;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.hiiker-branding.docked {
  position: static;
  flex: 0 0 auto;
  box-shadow: none;
  background: rgba(255, 255, 255, 0.08);
}

.hiiker-branding:hover {
  background: rgba(50, 52, 60, 0.95);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.hiiker-logo {
  height: 16px;
  width: auto;
}

.branding-text {
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
}

/* Responsive - hide text on very small screens */
@media (max-width: 400px) {
  .branding-text {
    display: none;
  }

  .hiiker-branding {
    padding: 6px 8px;
  }
}
</style>
